import { render } from "./contentSidescroll.vue?vue&type=template&id=a63e1c10"
import script from "./contentSidescroll.vue?vue&type=script&lang=js"
export * from "./contentSidescroll.vue?vue&type=script&lang=js"

import "./contentSidescroll.vue?vue&type=style&index=0&id=a63e1c10&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__